import React, { Component } from "react";

const CERT_ICONS = {
  Unity: "🎮",
  LinkedIn: "💼",
  Coursera: "📚",
  Rocketbot: "🤖",
  Domestika: "🎨",
};

class ExperienceGrid extends Component {
  constructor(props) {
    super(props);
    this.state = { carIdx: 0 };
    this.trackRef = React.createRef();
    this.outerRef = React.createRef();
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    this.setState({ carIdx: 0 });
  }

  getVisible() {
    if (!this.outerRef.current || !this.trackRef.current) return 4;
    const outerW = this.outerRef.current.offsetWidth;
    const slide = this.trackRef.current.querySelector(".cert-slide");
    const slideW = slide ? slide.offsetWidth + 16 : outerW / 4;
    return Math.max(1, Math.floor(outerW / slideW));
  }

  move(dir) {
    const total = this.props.resumeCourses
      ? this.props.resumeCourses.courses.length
      : 0;
    const vis = this.getVisible();
    const max = total - vis;
    this.setState((s) => ({
      carIdx: Math.max(0, Math.min(s.carIdx + dir, max)),
    }));
  }

  getOffset() {
    if (!this.trackRef.current) return 0;
    const slide = this.trackRef.current.querySelector(".cert-slide");
    if (!slide) return 0;
    return this.state.carIdx * (slide.offsetWidth + 16);
  }

  render() {
    let sectionName = "Certifications";
    let slides = null;

    if (this.props.resumeCourses) {
      sectionName = this.props.resumeCourses.header || "Certifications";
      slides = this.props.resumeCourses.courses.map((c, i) => {
        const icon = CERT_ICONS[c.school] || "📜";
        return (
          <div className="cert-slide" key={i}>
            <div className="cert-ico">{icon}</div>
            <div>
              <div className="cert-name">
                {c.url ? (
                  <a href={c.url} target="_blank" rel="noopener noreferrer">
                    {c.name}
                  </a>
                ) : (
                  c.name
                )}
              </div>
              <div className="cert-sub">
                {c.school} · {c.date}
              </div>
            </div>
          </div>
        );
      });
    }

    const total = slides ? slides.length : 0;
    const vis = this.getVisible();
    const max = total - vis;
    const { carIdx } = this.state;
    const offset = this.getOffset();

    return (
      <section id="certs">
        <div style={{ maxWidth: "1100px", margin: "0 auto" }}>
          <p className="sec-eye rv">{(this.props.resumeBasicInfo?.ui?.certs_eyebrow) || "Achievements"}</p>
          <h2 className="sec-h rv" style={{ transitionDelay: ".05s" }}>
            {sectionName.toUpperCase()}
          </h2>
          <div
            className="carousel-wrap rv"
            style={{ transitionDelay: ".1s" }}
          >
            <div className="carousel-track-outer" ref={this.outerRef}>
              <div
                className="carousel-track"
                ref={this.trackRef}
                style={{
                  transform: `translateX(-${offset}px)`,
                }}
              >
                {slides}
              </div>
            </div>
            <div className="carousel-btns">
              <button
                className="car-btn"
                onClick={() => this.move(-1)}
                disabled={carIdx === 0}
              >
                ←
              </button>
              <button
                className="car-btn"
                onClick={() => this.move(1)}
                disabled={carIdx >= max}
              >
                →
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ExperienceGrid;
